import { render, staticRenderFns } from "./CreateRoleDialog.vue?vue&type=template&id=09c575a9&scoped=true&"
import script from "./CreateRoleDialog.vue?vue&type=script&lang=js&"
export * from "./CreateRoleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c575a9",
  null
  
)

export default component.exports